// Palette exhaustive basée sur votre liste
export const hamaColors = [
  // COULEURS OPAQUES
  { id: '01', name: 'Blanc', hex: '#FFFFFF', r: 255, g: 255, b: 255 },
  { id: '02', name: 'Crème', hex: '#FDF5E6', r: 253, g: 245, b: 230 },
  { id: '03', name: 'Jaune', hex: '#F5D300', r: 245, g: 211, b: 0 },
  { id: '04', name: 'Orange', hex: '#E95D01', r: 233, g: 93, b: 1 },
  { id: '05', name: 'Rouge', hex: '#B72028', r: 183, g: 32, b: 40 },
  { id: '06', name: 'Rose foncé', hex: '#E76182', r: 231, g: 97, b: 130 },
  { id: '07', name: 'Violet', hex: '#5E2E88', r: 94, g: 46, b: 136 },
  { id: '08', name: 'Bleu foncé', hex: '#1C317A', r: 28, g: 49, b: 122 },
  { id: '09', name: 'Bleu clair', hex: '#0097D7', r: 0, g: 151, b: 215 },
  { id: '10', name: 'Vert clair', hex: '#009D57', r: 0, g: 157, b: 87 },
  { id: '11', name: 'Vert foncé', hex: '#006B3D', r: 0, g: 107, b: 61 },
  { id: '12', name: 'Marron', hex: '#5E3B24', r: 94, g: 59, b: 36 },
  { id: '17', name: 'Gris', hex: '#8E9092', r: 142, g: 144, b: 146 },
  { id: '18', name: 'Noir', hex: '#111111', r: 17, g: 17, b: 17 },
  { id: '20', name: 'Beige', hex: '#D2B48C', r: 210, g: 180, b: 140 },
  { id: '21', name: 'Saumon', hex: '#F18E72', r: 241, g: 142, b: 114 },
  { id: '22', name: 'Bordeaux', hex: '#800020', r: 128, g: 0, b: 32 },

  // COULEURS SPÉCIFIQUES DEMANDÉES
  { id: '53', name: 'Aubergine', hex: '#482A4D', r: 72, g: 42, b: 77 },
  { id: '50', name: 'Gris nuage', hex: '#D1D5D8', r: 209, g: 213, b: 216 },
  { id: '51', name: 'Rose poudré', hex: '#EBC0C7', r: 235, g: 192, b: 199 },
  { id: '98', name: 'Matcha', hex: '#97AB6F', r: 151, g: 171, b: 111 },
  { id: '95', name: 'Lilas pastel', hex: '#B5A6D3', r: 181, g: 166, b: 211 },
  { id: '97', name: 'Lavande', hex: '#9187B0', r: 145, g: 135, b: 176 },
  { id: '55', name: 'Midi 5', hex: '#3F51B5', r: 63, g: 81, b: 181 },

  // PASTELS
  { id: '43', name: 'Jaune Pastel', hex: '#FFF88E', r: 255, g: 248, b: 142 },
  { id: '44', name: 'Rouge Pastel', hex: '#FF9999', r: 255, g: 153, b: 153 },
  { id: '45', name: 'Violet Pastel', hex: '#D3B7D8', r: 211, g: 183, b: 216 },
  { id: '46', name: 'Bleu Pastel', hex: '#8EC9E8', r: 142, g: 201, b: 232 },
  { id: '47', name: 'Vert Pastel', hex: '#91D0B7', r: 145, g: 208, b: 183 },
  { id: '48', name: 'Rose Pastel', hex: '#F7C9D6', r: 247, g: 201, b: 214 },

  // NÉONS & MÉTAL
  { id: '37', name: 'Bleu néon', hex: '#00FFFF', r: 0, g: 255, b: 255 },
  { id: '78', name: 'Or', hex: '#D4AF37', r: 212, g: 175, b: 55 },
  { id: '79', name: 'Argent', hex: '#C0C0C0', r: 192, g: 192, b: 192 }
];

export const hamaColorCategories = [
  {
    name: 'standard',
    displayName: 'Standard / Opaque',
    colors: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '17', '18', '20', '21', '22']
  },
  {
    name: 'special',
    displayName: 'Couleurs de la Liste',
    colors: ['53', '50', '51', '98', '95', '97', '55']
  },
  {
    name: 'pastel',
    displayName: 'Pastels',
    colors: ['43', '44', '45', '46', '47', '48']
  }
];